import { useMemo } from 'react';
import { useGrades } from '../../Common/hooks/useGrades';
import { useStandards } from '../../Common/hooks/useStandards';
import { useDomains } from '../../Common/hooks/useDomains';
import { useSkills } from '../../Common/hooks/useSkills';
var usePrintablesDictionaries = function () {
    var skillItems = useSkills().response;
    var domainItems = useDomains().response;
    var standardItems = useStandards().response;
    var gradeItems = useGrades().response;
    var skills = useMemo(function () {
        var parsedSkills = [];
        if (skillItems) {
            parsedSkills = skillItems.map(function (_a) {
                var id = _a.id, name = _a.name, data = _a.data;
                return ({
                    id: "skill" + id,
                    text: name,
                    value: {
                        domainId: data.domainId,
                        gradeId: data.gradeId,
                        type: 'skill',
                    },
                });
            });
        }
        return parsedSkills;
    }, [skillItems]);
    var standards = useMemo(function () {
        var parsedStandards = [];
        if (standardItems) {
            parsedStandards = standardItems.map(function (_a) {
                var id = _a.id, name = _a.name, data = _a.data;
                return ({
                    id: "standard" + id,
                    text: name,
                    value: {
                        gradeIds: data.gradeIds,
                        type: 'standard',
                    },
                });
            });
        }
        return parsedStandards;
    }, [standardItems]);
    var domains = useMemo(function () {
        var parsedDomains = [];
        if (domainItems)
            parsedDomains = domainItems;
        return parsedDomains;
    }, [domainItems]);
    var grades = useMemo(function () {
        var filteredGrades = [];
        if (gradeItems) {
            filteredGrades = gradeItems.filter(function (_a) {
                var id = _a.id;
                return id !== -1;
            });
        }
        return filteredGrades;
    }, [gradeItems]);
    return [skills, standards, domains, grades];
};
export { usePrintablesDictionaries };
